import { matchPath, useLocation } from "react-router-dom";
import styled from "styled-components";
import { pages } from "src/utils";
import { Button, Color, Flex, Text } from "src/elements";
import { zIndexLevel } from "src/utils/zIndexLevels";
import { useTranslation } from "src/i18n";
import { useTour } from "./store/hooks";

const Offer = styled.div`
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 340px;
  box-sizing: border-box;
  padding: 16px;
  background: ${Color.white};
  border: 1px solid ${Color.primary};
  border-radius: 5px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  z-index: ${zIndexLevel.L10};
`;

/**
 * Offered once, the first time a user is seen in this browser. A corner card
 * rather than a modal: someone who logged in to do something can carry on and
 * come back to it, and the sidebar keeps the exercise within reach afterwards.
 */
/**
 * Rendered by the backend in a headless browser with an empty localStorage, to
 * make thumbnails and PDFs. An offer there would be printed into every one.
 */
const RENDER_ONLY_PAGES = [
  pages.merchflowsPogThumbnail_basePogId_,
  pages.merchflowsPogThumbnail_storePogId_,
  pages.merchflowsPogExportPdf_basePogId_,
  pages.merchflowsPogExportPdf_storePogId_,
];

export const TourOffer = () => {
  const { state, hasBeenOffered, start, dismissOffer } = useTour();
  const { pathname } = useLocation();
  const { t } = useTranslation("common");

  if (hasBeenOffered || state) return null;
  if (RENDER_ONLY_PAGES.some((page) => matchPath(page, pathname))) return null;

  return (
    <Offer role="dialog" aria-label={t("tour.offer.title")} data-testid="tour-offer">
      <Flex column gap="10px">
        <Text variant="h5" color={Color.primaryActive}>
          {t("tour.offer.title")}
        </Text>

        <Text variant="body3" color={Color.textSecondary}>
          {t("tour.offer.body")}
        </Text>

        <Flex justify="right" gap="8px">
          <Button name="tour-offer-dismiss" size="small" variant="inverted" onClick={dismissOffer}>
            {t("tour.offer.dismiss")}
          </Button>

          <Button name="tour-offer-start" size="small" onClick={() => void start()}>
            {t("tour.offer.start")}
          </Button>
        </Flex>
      </Flex>
    </Offer>
  );
};
